import React from 'react';
import { __, sprintf } from '@wordpress/i18n';

interface Props {
  page?: number;
  isCurrent: boolean;
  onClick: (page: number) => void;
  ariaLabel?: string;
  className?: string;
  ariaDisabled?: boolean;
}

const scrollToJobListing = (): void => {
  const el = document.getElementById('job-listing');
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const PageLink: React.FC<Props> = ({
  page, isCurrent, onClick, className, ariaLabel, ariaDisabled,
}) => (
  isCurrent ? (
    <span
      className={`${className || ''} page-numbers current`}
      aria-label={ariaLabel || sprintf(__('Current page, page %d', 'wp-plugin-jobs'), page)}
      aria-current="page"
    >
      {page}
    </span>
  ) : (
    <a
      className={`${className || ''} page-numbers`}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        scrollToJobListing();
        onClick(page);
      }}
      href="#"
      aria-disabled={ariaDisabled}
      aria-label={ariaLabel || sprintf(__('Go to page %d', 'wp-plugin-jobs'), page)}
    >
      {page}
    </a>
  )
);

export default PageLink;
